export default "__VITE_ASSET__g5Nyqld6__"